import { createApp } from 'vue'
import App from './App.vue'
import PrimeVue from 'primevue/config'
import Aura from '@primeuix/themes/aura'
import 'primeicons/primeicons.css'
import 'primeflex/primeflex.css'
import './assets/main.css'
import { definePreset } from '@primeuix/themes'
import AnimateOnScroll from 'primevue/animateonscroll'
import router from '@/router'

const app = createApp(App)

app.use(router)

const customAura = definePreset(Aura, {
  semantic: {
    colorScheme: {
      dark: {
        surface: {
          0: '#18181b',
        },
        primary: {
          color: '#45baff',
          inverseColor: '#000000',
          hoverColor: '#72caff',
          activeColor: '#0073a1',
        },
        highlight: {
          background: '#caff01',
          focusBackground: '#d6ff4d',
          color: '#000000',
          focusColor: '#000000',
        },
        text: {
          color: '#ffffff',
        },
      },
    },
  },
})

app.use(PrimeVue, {
  theme: {
    preset: customAura,
    options: {
      prefix: 'p',
      darkModeSelector: '.dark-mode',
      cssLayer: {
        name: 'primevue',
        order: 'theme, base, primevue',
      },
    },
  },
})

app.directive('animateonscroll', AnimateOnScroll)

const webSiteConfig: WebSiteConfig = window.__APP_CONFIG__

app.config.globalProperties.$webSiteConfig = webSiteConfig

app.mount('#app')
